import { IUser, IVirtualView } from 'kach-clients'

export const buildVirtualViewQueryKey = (
  resource: IVirtualView['resource'],
  auth: IUser,
) => `'virtual-views-${resource}-user-${auth.id}`
